import { FlexBox } from '@trmediaab/zebra';

import BoxedContent from '~/components/StartList/BoxedContent';
import { access_control } from '~/containers/Auth/AccessControl';
import KeyStartRace from '~/containers/KeyStartRace';
import PreliminaryEquipments from '~/containers/PreliminaryEquipments';

import KeyStartItem from '../KeyStartItem';
import PreliminaryEquipmentsList from '../PreliminaryEquipmentsList';
import Ranking from '../Ranking';
import RoundText from '../RoundText';

const showRanking = race => {
  for (const i in race.starts) {
    if (race.starts[i].ranking && race.starts[i].ranking.weight) {
      return true;
    }
  }
  return false;
};

const LegTips = ({ leg_number, bet_type, race }) => (
  <FlexBox
    columnGap="2"
    rowGap="3"
    backgroundColor="background.secondary"
    sx={{
      borderTop: '8px solid',
      borderTopColor: 'background.secondary',
    }}
    flexDirection={{
      xs: 'column',
      lg: 'row',
    }}
  >
    <FlexBox
      flexDirection="column"
      gap="3"
      flex={{
        xs: undefined,
        lg: '1',
      }}
      sx={{
        '&:empty': {
          display: 'none',
        },
      }}
    >
      {showRanking(race) && (
        <BoxedContent
          title="RANKING"
          display={{
            xs: 'block',
            lg: 'none',
          }}
        >
          <Ranking starts={race.starts} bet_type={bet_type} />
        </BoxedContent>
      )}

      <KeyStartRace
        race={race.id}
        render={keyStartRace => (
          <BoxedContent title="SPETSANALYS">
            <KeyStartItem items={keyStartRace} type="front_favorite" />
          </BoxedContent>
        )}
      />

      {race.analysis && race.analysis.text && (
        <BoxedContent title="LOPPANALYS">
          <RoundText text={race.analysis.text} />
        </BoxedContent>
      )}
      <PreliminaryEquipments
        race={race.slug}
        render={preliminaryEquipments => (
          <BoxedContent
            title="UTRUSTNINGSÄNDRINGAR"
            display={{
              xs: 'none',
              lg: 'block',
            }}
          >
            <PreliminaryEquipmentsList
              preliminaryEquipments={preliminaryEquipments}
              bet_type={bet_type}
              leg={leg_number}
            />
          </BoxedContent>
        )}
      />
    </FlexBox>

    <FlexBox
      flexDirection="column"
      gap="3"
      flex={{
        xs: undefined,
        lg: '0.7',
      }}
      sx={{
        '&:empty': {
          display: 'none',
        },
      }}
    >
      {showRanking(race) && (
        <BoxedContent
          title="RANKING"
          display={{
            xs: 'none',
            lg: 'block',
          }}
        >
          <Ranking starts={race.starts} bet_type={bet_type} />
        </BoxedContent>
      )}

      {race.analysis?.text2 && (
        <BoxedContent title="TÄNK PÅ ATT">
          <RoundText text={race.analysis.text2} />
        </BoxedContent>
      )}

      <PreliminaryEquipments
        race={race.slug}
        render={preliminaryEquipments => (
          <BoxedContent
            title="UTRUSTNINGSÄNDRINGAR"
            display={{
              xs: 'block',
              lg: 'none',
            }}
          >
            <PreliminaryEquipmentsList
              preliminaryEquipments={preliminaryEquipments}
              bet_type={bet_type}
              leg={leg_number}
            />
          </BoxedContent>
        )}
      />
    </FlexBox>
  </FlexBox>
);

export default access_control(LegTips);
